import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import useGenreSelectorOptions from '../../hooks/useGenreSelectorOptions';
import useGenre from '../../hooks/useGenre';
import { Provider } from './context';
import { channelRecommendationTypes } from '@/config/events-keakie';
import sendChannelViewEvent from '@/helpers/api/events/sendChannelViewEvent';

const GenrePageProvider = ({ children }) => {
  const { genre } = useGenre();
  const { id: genreId } = genre;

  const { selectorOptions, selectedGenre } = useGenreSelectorOptions();

  const onClickChannel = useCallback((channel) => {
    sendChannelViewEvent({
      channelId: channel.id,
      recommendationType: channelRecommendationTypes.CHILD_GENRES,
      recommendationId: genreId
    }).catch(_ => _);
  }, [genreId]);

  const value = useMemo(() => ({
    selectorOptions,
    selectedGenre,
    onClickChannel
  }), [selectorOptions, selectedGenre, onClickChannel]);

  return (
    <Provider value={ value }>
      { children }
    </Provider>
  );
};

GenrePageProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};
    
export default GenrePageProvider;